<div [formGroup]="formGroup" class="flex flex-col w-full" *transloco="let t">
  <mat-form-field appearance="outline" class="fuse-mat-dense flex-auto">
    @if (label) {
      <mat-label>{{ t(label) | capitalize }}</mat-label>
    }

    <input
      matInput
      type="email"
      (keydown.space)="$event.preventDefault()"
      [name]="controlName"
      [placeholder]="placeholder"
      [formControlName]="controlName"
      [autocomplete]="autocomplete"
    />
    @if (icon) {
      <mat-icon matSuffix [ngClass]="'icon-size-' + iconSize" svgIcon="{{ icon }}"></mat-icon>
    }

    @if (formControl?.errors ?? {} | firstErrorMessage: formControl : errorMessages; as errorMessage) {
      <mat-error>{{ t(errorMessage) | capitalize }}</mat-error>
    }
  </mat-form-field>
</div>
